import React, { useState, useRef, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import "./GetAQuote.css";
import "./form.css";

import ReCAPTCHA from "react-google-recaptcha";
import {
  TextField,
  Button,
  Box,
} from "@mui/material";

import { Container, Col, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";

import axios from "axios";

import {
  CountryDropdown,
  RegionDropdown,
} from "react-country-region-selector";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Select from "react-select";

import { useDropzone } from "react-dropzone";

export default function QuoteModal({ show, handleClose }) {

  const [selectedFile, setSelectedFile] = useState(null);
  const [base64Data, setBase64Data] = useState("");
  const [loading, setLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [componentKey, setComponentKey] = useState(0);

  const fileInputRef = useRef(null);
  const captchaRef = useRef(null);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitted },
    control,
  } = useForm();

  const optionSelect = [
    { value: "iOS App Development", label: "iOS App Development" },
    { value: "Android App Development", label: "Android App Development" },
    { value: "Web Development", label: "Web Development" },
    {
      value: "Enterprise Software Development",
      label: "Enterprise Software Development",
    },
    { value: "Others", label: "Others" },
  ];

  const [country, setCountry] = useState("");
  const [region, setRegion] = useState("");

  const selectCountry = (val) => setCountry(val);

  const selectRegion = (val) => {
    setRegion(val);
  };

  useEffect(() => {
    if (showToast) {
      toast.success(toastMessage);
      setShowToast(false);
    }
  }, [showToast, toastMessage]);

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      data.image = base64Data;
      data.countryname = country;
      data.regionname = region;

      const baseURL = process.env.REACT_APP_API_URL;

      await axios.post(
        `${baseURL}/api/mailsend/servicesgetaquotereceivedbyhost`,
        data
      );

      await axios.post(
        `${baseURL}/api/mailsend/servicesquoterequestconfirmforuser`,
        data
      );

      captchaRef.current.getValue();
      captchaRef.current.reset();

      setToastMessage("Success! Your form has been submitted.");
      setShowToast(true);

      setSelectedFile(null);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      setComponentKey((prevKey) => prevKey + 1);

      handleClose();

    } catch (error) {
      console.error("Error submitting form:", error);

      setToastMessage("Submission failed. Please try again.");
      setShowToast(true);

    } finally {
      setLoading(false);

      reset({
        service: [],
        name: "",
        email: "",
        country_code: "",
        phone: "",
        location: "",
        subject: "",
        message: "",
      });

      setCountry("");
      setRegion("");
      setBase64Data("");
    }
  };

  const trimFileName = (fileName) => {
    if (fileName.length <= 15) {
      return fileName;
    }

    return `${fileName.substring(0, 12)}...`;
  };

  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setBase64Data(reader.result);
        setSelectedFile(file);
      };

      reader.readAsDataURL(file);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept:
      "image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  });

  const onCaptchaComplete = (response) => {
    console.log(response);
  };

  return (
    <>
      <ToastContainer position="top-center" />

      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        aria-labelledby="example-modal-sizes-title-lg"
        dialogClassName="modalbox-size"
      >
        <Modal.Header closeButton className="quote-header">
          <p className="heading-quote">Get a free quote?</p>
        </Modal.Header>

        <Modal.Body>
          <div key={componentKey} className="services-form-container">
            <div className="mainForm getaquote-form">

              <form
                className="form_container p-0"
                onSubmit={handleSubmit(onSubmit)}
              >
                <Row
                  className="form-row m-0"
                  style={{ height: "auto", width: "auto" }}
                >
                  <Col
                    sm={12}
                    lg={12}
                    md={12}
                    className="form-col getaquote-form-col"
                  >
                    <Container className="formContainer">

                      {/* Services */}

                      <Controller
                        name="service"
                        control={control}
                        rules={{
                          required: "Please select at least one service",
                        }}
                        render={({ field }) => (
                          <div>
                            <Select
                              isMulti
                              {...field}
                              options={optionSelect}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              placeholder="Select Services"
                              menuPortalTarget={document.body}
                              styles={{
                                placeholder: (base) => ({
                                  ...base,
                                  color:
                                    isSubmitted &&
                                    !field.value &&
                                    errors?.service
                                      ? "red"
                                      : "gray",
                                  textAlign: "left",
                                }),

                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />

                            {errors?.service && (
                              <p
                                style={{
                                  color: "red",
                                  marginTop: "5px",
                                }}
                              >
                                {errors.service.message}
                              </p>
                            )}
                          </div>
                        )}
                      />

                      {/* Name */}

                      <TextField
                        fullWidth
                        label="Full Name"
                        margin="dense"
                        variant="filled"
                        autoComplete="off"
                        className="textfield"
                        {...register("name", {
                          required: "Required",
                          minLength: 3,
                        })}
                        error={!!errors?.name}
                      />

                      {/* Email */}

                      <TextField
                        fullWidth
                        label="Email"
                        margin="dense"
                        variant="filled"
                        autoComplete="off"
                        className="textfield"
                        {...register("email", {
                          required: "Required field",
                          pattern: {
                            value:
                              /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
                            message: "Invalid email address",
                          },
                        })}
                        error={!!errors?.email}
                      />

                      {/* Phone */}

                      <div className="tel">

                        <TextField
                          placeholder="USA +1"
                          label="Country Code"
                          type="number"
                          margin="dense"
                          variant="filled"
                          className="txtfield_country_code"
                          {...register("country_code", {
                            required: "Required",
                          })}
                          error={!!errors?.country_code}
                        />

                        <TextField
                          label="Phone"
                          margin="dense"
                          type="number"
                          variant="filled"
                          placeholder="Landline/Mobile Number"
                          className="txtfield_phone"
                          {...register("phone", {
                            required: "Required",
                          })}
                          error={!!errors?.phone}
                        />
                      </div>

                      {/* Country Region */}

                      <div className="country-region-services">

                        <CountryDropdown
                          className="input-field select"
                          value={country}
                          style={{
                            backgroundColor: "#e9ecef",
                            borderRadius: "9px",
                          }}
                          onChange={(val) => selectCountry(val)}
                        />

                        <RegionDropdown
                          className="input-field select"
                          country={country}
                          value={region}
                          style={{
                            backgroundColor: "#e9ecef",
                            borderRadius: "9px",
                          }}
                          blankOptionLabel="Select Region"
                          onChange={(val) => selectRegion(val)}
                        />
                      </div>

                      {/* City */}

                      <TextField
                        fullWidth
                        label="City"
                        margin="dense"
                        variant="filled"
                        className="txtfield_country_code"
                        {...register("location", {
                          required: "Required",
                        })}
                        error={!!errors?.location}
                      />

                      {/* Subject */}

                      <TextField
                        fullWidth
                        label="Subject"
                        margin="dense"
                        variant="filled"
                        className="txtfield_country_code"
                        {...register("subject", {
                          required: "Required",
                        })}
                        error={!!errors?.subject}
                      />

                      {/* Message */}

                      <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label="Please tell us what you are looking for?"
                        margin="dense"
                        variant="filled"
                        className="txtfield_country_code message_box"
                        {...register("message", {
                          required: "Required",
                        })}
                        error={!!errors?.message}
                      />

                      {/* Upload */}

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          {...getRootProps()}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            marginBottom: "1rem",
                            marginTop: "7px",
                            cursor: "pointer",
                          }}
                          className="responsive-upload-box"
                        >
                          <input
                            {...getInputProps()}
                            style={{ display: "none" }}
                          />

                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "white",
                              color: "black",

                              "&:hover": {
                                backgroundColor: "white",
                                color: "black",
                              },

                              padding: "5px 40px 5px 10px",
                              display: "flex",
                              alignItems: "center",
                              position: "relative",
                            }}
                            className="responsive-upload-button"
                          >
                            {selectedFile
                              ? trimFileName(selectedFile.name)
                              : "Upload File"}

                            {selectedFile && (
                              <span
                                onClick={(event) => {
                                  event.stopPropagation();

                                  setSelectedFile(null);
                                  setBase64Data("");

                                  if (fileInputRef.current) {
                                    fileInputRef.current.value = "";
                                  }
                                }}
                                style={{
                                  position: "absolute",
                                  top: "-10px",
                                  right: "-10px",
                                  backgroundColor: "#ff6666",
                                  borderRadius: "50%",
                                  width: "20px",
                                  height: "20px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "white",
                                  fontSize: "12px",
                                  cursor: "pointer",
                                  boxShadow:
                                    "0px 2px 5px rgba(0,0,0,0.2)",
                                }}
                              >
                                &times;
                              </span>
                            )}
                          </Button>
                        </Box>
                      </div>

                      {/* Recaptcha */}

                      <div style={{ marginTop: 7, marginBottom: 8 }}>
                        <ReCAPTCHA
                          sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                          ref={captchaRef}
                          onChange={onCaptchaComplete}
                          className="my-recaptcha"
                        />
                      </div>

                      {/* Submit */}

                      <div className="buttonsubmit quote-btn-submit">

                        <Button
                          style={{
                            display: "block",
                            margin: "auto",
                            width: "7rem",
                            color: "white",
                            backgroundColor: "#3b6da7",
                          }}
                          type="submit"
                          variant="contained"
                        >
                          {loading ? (
                            <div
                              className="spinner-border text-light"
                              role="status"
                              style={{ fontSize: "1.2rem" }}
                            >
                              <span className="sr-only">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            "Submit"
                          )}
                        </Button>

                      </div>

                    </Container>
                  </Col>
                </Row>
              </form>

            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}